import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
export default function DateField({ date, timezone, showTime }) {
    if (!date) {
        return null;
    }
    const momentObj = timezone ? moment(date).tz(timezone) : moment(date);
    return ((React.createElement("div", { "data-testid": "div-d661e874", className: "text-sm" },
        React.createElement("p", { "data-testid": "p-f54dd508", className: "my-0" }, momentObj.format('L')),
        showTime && React.createElement("p", { "data-testid": "p-96218eae", className: "my-0" }, momentObj.format('LT')))));
}
DateField.propTypes = {
    showTime: PropTypes.bool,
};
DateField.defaultProps = {
    showTime: true,
};
